<template>
  <div class="countdown" v-show="countdownCnt !== 0">
    <div class="countdown-title">
      <h2>报名倒计时</h2>
      <div class="title-items">
        <ul>
          <li
            v-for="(item, index) in countdownArr"
            :key="index"
            :data-code="item.CategoryCode"
            :class="countdownActive === index ? 'active' : ''"
            @click="countdownActive = index"
            v-show="countdownItemShow[index]"
          >{{ getCountdownItem(item.Name) }}</li>
        </ul>
      </div>
    </div>
    <div class="countdown-content">
      <div class="ad-box">
        <ad-model adCode="639"></ad-model>
      </div>
      <div
        class="course-box"
        v-for="(countdownCourse, countdownCourseIndex) in countdownArr"
        :key="countdownCourseIndex"
        :data-code="countdownCourse.CategoryCode"
        v-show="countdownActive === countdownCourseIndex"
      >
        <div class="courseTop">
          <a
            :class="['course', index === 3 ? 'noborder' : '']"
            v-for="(item, index) in countdownCourseTop[countdownCourseIndex]"
            :key="item.Code"
            :href="`http://souke.xdf.cn/Class/${cityId}-${item.Id}.html`"
          >
            <p class="title">{{ item.Name }}</p>
            <p class="teacher">主讲教师：{{ handleTeacherName(item.TeacherList) }}</p>
            <p class="address">{{ item.LearnPlace }}</p>
            <p class="time">{{ item.StartDate.split('T')[0] }} 至 {{ item.EndDate.split('T')[0] }}</p>
            <p class="price-days">
              <span class="price">￥{{ item.Price }}</span>
              <span class="days">报名截止<i>{{ getDay(item.StartDate) }}</i>天</span>
            </p>
          </a>
        </div>
        <div class="courseBottom">
          <a
            :class="['course', index === 3 ? 'noborder' : '']"
            v-for="(item, index) in countdownCourseBottom[countdownCourseIndex]"
            :key="item.Code"
            :href="`http://souke.xdf.cn/Class/${cityId}-${item.Id}.html`"
          >
            <p class="title">{{ item.Name }}</p>
            <p class="teacher">主讲教师：{{ handleTeacherName(item.TeacherList) }}</p>
            <p class="address">{{ item.LearnPlace }}</p>
            <p class="time">{{ item.StartDate.split('T')[0] }} 至 {{ item.EndDate.split('T')[0] }}</p>
            <p class="price-days">
              <span class="price">￥{{ item.Price }}</span>
              <span class="days">报名截止<i>{{ getDay(item.StartDate) }}</i>天</span>
            </p>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getClassBySearch } from 'js/getSoukeData.js'
import AdModel from '@/common-components/AdModel'
import Loading from '@/common-components/Loading'
export default {
  name: 'Countdown',
  components: {
    AdModel,
    Loading
  },
  data () {
    return {
      countdownActive: 0,
      countdownArr: [],
      firstItem: true,
      firstIndex: 0,
      countdownCnt: 0,
      countdownItemShow: [],
      temptItemArr: [],
      countdownCourseTop: [],
      countdownCourseBottom: [],
      categoryCodeArr: {
        '学前辅导': 318,
        '小学辅导': 40,
        '中学辅导': 414,
        '大学辅导': 20,
        '英语学习': 6,
        '出国留学': 145,
        '夏冬令营': 110,
        '冬夏令营': 110,
        '小语种': 79
      }
    }
  },
  computed: {
    getCountdownItem () {
      return function (name) {
        if (name === '小语种' || name === '冬夏令营' || name === '国际游学' || name === '夏冬令营') {
          return name
        } else {
          return name.slice(0, 2)
        }
      }
    },
    cityId () {
      return this.soukecityId
    },
    nav () {
      return this.topNav
    },
    handleTeacherName () {
      return function (teacherName) {
        return teacherName.length !== 0 ? teacherName[0].Name : '待定'
      }
    },
    getDay () {
      return function (classStartDate) {
        let currentDate = new Date()
        let startDate = new Date(classStartDate)
        let day = (startDate - currentDate) / 1000 / 3600 / 24
        classStartDate = classStartDate.replace('T', ' ')
        classStartDate = classStartDate.replace(/-/g, '/')
        return Math.ceil(day)
      }
    },
    getAttr () {
      return function (name) {
        if (name === '初中生') {
          return 934
        } else if (name === '高中生') {
          return 935
        } else {
          return 0
        }
      }
    },
    categoryCodeEmpty () {
      return function (originCode, arrCode) {
        if (originCode) {
          return originCode
        } else {
          return arrCode
        }
      }
    },
    ...mapState(['soukecityId', 'cityName', 'topNav'])
  },
  watch: {
    cityId (newVal) {
      return newVal
    },
    nav (newVal) {
      this.countdownInit()
      this.countdownArr = newVal
      this.getCountdownData(this.cityId, 0)
    }
  },
  created () {
    this.countdownInit()
    this.getCountdownData(this.cityId, 0)
  },
  methods: {
    countdownInit () {
      this.countdownActive = 0
      this.countdownArr = []
      this.firstItem = true
      this.firstIndex = 0
      this.countdownCnt = 0
      this.countdownItemShow = []
      this.temptItemArr = []
      this.countdownCourseTop = []
      this.countdownCourseBottom = []
    },
    getCountdownData (cityId, index) {
      let _this = this
      if (index > this.countdownArr.length - 1) {
        this.countdownItemShow = this.temptItemArr
        return
      }
      getClassBySearch(cityId, 8, this.categoryCodeEmpty(this.countdownArr[index].CategoryCode, this.categoryCodeArr[this.countdownArr[index].Name]), this.getAttr(this.countdownArr[index].Name)).then(response => {
        response = response.ClassList
        if (response && response.length === 8) {
          let tempTop = []
          let tempBottom = []
          this.countdownCnt += 1
          if (_this.firstItem) {
            _this.firstItem = false
            _this.firstIndex = index
            _this.countdownActive = index
          }
          response.forEach((item, index) => {
            if (index < 4) {
              tempTop.push(item)
            } else {
              tempBottom.push(item)
            }
          })
          this.temptItemArr.push(true)
          _this.countdownCourseTop.push(tempTop)
          _this.countdownCourseBottom.push(tempBottom)
        } else {
          this.temptItemArr.push(false)
          _this.countdownCourseTop.push([])
          _this.countdownCourseBottom.push([])
        }
        index += 1
        _this.getCountdownData(cityId, index)
      }, error => {
        console.log(error)
        this.temptItemArr.push(false)
        index += 1
        _this.getCountdownData(cityId, index)
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
@import '~styles/mixins.styl'
.active
  border-left: 1px solid #98dfd2
  border-right: 1px solid #98dfd2
  border-top: 2px solid #00b388
  background: #fff
  color: $themeColor !important
  height: 42px
  margin-top: -2px
.countdown
  width: 1200px
  height: 377px
  margin: 18px auto
  display: flex
  flex-direction: column
  .countdown-title
    height: 40px
    line-height: 40px
    padding-left: 16px
    background-color: #f3f3f3
    border-bottom: 2px solid #98dfd2
    display: flex
    h2
      font-size: 18px
      flex: 1
      float:left
      width:236px
    .title-items
      flex: 4
      float:left
      ul
        li
          float: $fl
          color: #606060
          font-size: 16px
          padding: 0 20px
          cursor: pointer
  .countdown-content
    flex: 1
    display: flex
    .ad-box
      width: 176px
      height: 100%
    .course-box
      flex: 1
      display: flex
      flex-direction: column
      padding: 11px 0
      float:left
      .courseTop
        flex: 1
        display: flex
        clear: both
        border-bottom: 1px solid #eee
        border-bottom :none
        .course
          flex: 1
          display: flex
          padding: 15px 36px
          max-width: 183px
          flex-direction: column
          border-right: 1px solid #eee
          float:left
          width:256px
          height:120px
          &:hover
            .title
              color: $themeColor
          p
            flex: 1
            ellipsis()
            line-height: 25px
            white-space: nowrap
          .title
            font-size: 14px
            color: #3f3f3f
          .teacher
            color: #666
          .address
            color: #9c9c9c
            padding-left: 18px
            background: url(http://images.xdf.cn/cms20150819/zuixinban/images/adress.png) no-repeat 3px 6px
          .time
            color: #9c9c9c
            padding-left: 18px
            background: url(http://images.xdf.cn/cms20150819/zuixinban/images/guess_time.png) no-repeat 3px 6px
          .price-days
            color: #3f3f3f
            display: flex
            .price
              flex: 1
              color: #ff7011
              font-size: 18px
              text-align: center
            .days
              flex: 2
              color: $themeColor
              text-align: center
              float: right
              i
                color: #fff
                height: 14px
                line-height: 14px
                margin-left: 1px
                margin-right: 1px
                border-radius: 2px
                font-size: 14px
                padding: 0px 2px 0px 2px
                background-color: $themeColor
        .noborder
          border-right: 0
      .courseBottom
        flex: 1
        display: flex
        clear :both
        border-top:1px solid #eeeeee
        .course
          flex: 1
          display: flex
          padding: 20px 36px
          max-width: 183px
          flex-direction: column
          border-right: 1px solid #eee
          float:left
          &:hover
            .title
              color: $themeColor
          p
            flex: 1
            ellipsis()
            line-height: 25px
            white-space: nowrap
          .title
            font-size: 14px
            color: #3f3f3f
          .teacher
            color: #666
          .address
            color: #9c9c9c
            padding-left: 18px
            background: url(http://images.xdf.cn/cms20150819/zuixinban/images/adress.png) no-repeat 3px 6px
          .time
            color: #9c9c9c
            padding-left: 18px
            background: url(http://images.xdf.cn/cms20150819/zuixinban/images/guess_time.png) no-repeat 3px 6px
          .price-days
            color: #3f3f3f
            display: flex
            .price
              flex: 1
              color: #ff7011
              font-size: 18px
              text-align: center
            .days
              flex: 2
              color: $themeColor
              text-align: center
              float: right
              i
                color: #fff
                height: 14px
                line-height: 14px
                margin-left: 1px
                margin-right: 1px
                border-radius: 2px
                font-size: 14px
                padding: 0px 2px 0px 2px
                background-color: $themeColor
        .noborder
          border-right: 0
</style>



// WEBPACK FOOTER //
// src/pages/home/components/Countdown.vue